import { render, staticRenderFns } from "./Handbooks.vue?vue&type=template&id=d4c5ab56&lang=pug&"
import script from "./Handbooks.vue?vue&type=script&lang=js&"
export * from "./Handbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports